export const pointsToYen = (points: string | number, isDisplayedDecimal = false): string => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return points.toString();
  }

  const yenValue = num / 10; // Convert points to yen
  if (isDisplayedDecimal) {
    if (yenValue < 1) {
      return yenValue.toFixed(1); // Return unrounded value with one decimal place
    }
  }

  return Math.floor(yenValue).toLocaleString();
};

export const pointsToYenForCalculations = (points: string | number): number => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return 0;
  }
  const yenValue = num / 10;
  return Math.floor(yenValue);
};

export const yenToPoints = (yen: number): number => {
  return Math.floor(yen * 10);
};
